module.exports = __webpack_public_path__ + "static/media/1920-service-2-2-min.ca5fe190.jpg";